import React from "react";
import classNames from "classnames/bind";
import {
  // DateTimePicker,
  InputTextBox,
  SelectBox,
  SelectBoxItem,
} from "../../../../components";
import useFetchData from "../../../../hooks/useFetchData";
import styles from "./AddRole.module.css";

const cx = classNames.bind(styles);
const FormAdd = ({ setNewRole, newRole, action = "edit", onChange }) => {
  const onChangeNewRole = (data) => {
    setNewRole({
      ...newRole,
      subject_name: data,
    });
  };
  const onChangeDescription = (data) => {
    setNewRole({
      ...newRole,
      note: data,
    });
  };
  // const handleOnchange = (data) => {
  //   if (action === "add") {
  //     onChange(data)
  //   }
  // }
  // const { data } = useFetchData("/userType/get-list-userType/", {
  //   company_code: sessionStorage.getItem("company_code"),
  // });
  return (
    <div className={cx("form-add")}>
      <div className={cx("header", "sub")}>
        <h1 className={cx("title", "sub-title")}>Thông tin chung</h1>
      </div>
      <div className={cx("form")}>
        <>
          <InputTextBox
            style={{ marginBottom: 16 }}
            type="text"
            placeholder="Nhập"
            title={action === 'add' ? "Quyền mới" : "Tên quyền"}
            onChange={onChangeNewRole}
            value={newRole?.subject_name}
          />
          <InputTextBox
            style={{ marginBottom: 16 }}
            type="text"
            placeholder="Nhập"
            title="Mô tả"
            onChange={onChangeDescription}
            value={newRole?.note}
          />
        </>
      </div>
    </div>
  );
};

export default FormAdd;
